import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';

import { Input } from '../input/Input';
import { ConfirmationInputTypes, InputUserDecision } from './ConfirmationInput.types';
import { ConfirmationAdornment } from './confirmationAdornment/ConfirmationAdornment';

export const ConfirmationInput = memo(
  ({
    value,
    mask,
    size,
    className,
    label,
    inputRef,
    name,
    error,
    checkAdornment,
    hideConfirmationAdortment,
    onChange,
    onBlur,
    onConfirmation,
  }: ConfirmationInputTypes) => {
    const [hasUserDecided, setUserDecide] = useState<InputUserDecision>(InputUserDecision.Untouched);

    const isAnyAdornmentActionClicked = useMemo(
      () => (hideConfirmationAdortment ? true : hasUserDecided !== InputUserDecision.Untouched),
      [hideConfirmationAdortment, hasUserDecided],
    );

    const handleChange = useCallback(
      (value: string) => {
        setUserDecide(InputUserDecision.Confirmed);
        onChange(value);
      },
      [onChange],
    );

    const handleAdornmentReject = useCallback(() => {
      setUserDecide(InputUserDecision.Rejected);
      onChange('');
    }, [onChange]);

    useEffect(() => {
      if (!isAnyAdornmentActionClicked) {
        return;
      }

      onConfirmation(isAnyAdornmentActionClicked);
    }, [onConfirmation, isAnyAdornmentActionClicked]);

    return (
      <Input
        name={name}
        inputRef={inputRef}
        className={className}
        fullWidth
        label={label}
        value={value}
        onChange={e => handleChange(e.target.value)}
        mask={mask}
        error={error}
        variant="outlined"
        onBlur={onBlur}
        size={size}
        checkAdornment={checkAdornment && isAnyAdornmentActionClicked}
        endAdornment={
          !isAnyAdornmentActionClicked && (
            <ConfirmationAdornment
              onConfirm={() => setUserDecide(InputUserDecision.Confirmed)}
              onReject={handleAdornmentReject}
            />
          )
        }
      />
    );
  },
);
